/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

export abstract class BrokerSettingService {
   /**
    * @public
    * @param {[type]} brokerAddress [description]
    * @param {[type]} username      [description]
    * @param {[type]} domain        [description]
    */
   public abstract setLastADConnectionInfo(brokerAddress, username, domain);
   public abstract getLastADConnectionInfo(brokerAddress);
}
